export const ru = {
    error: 'С ошибкой',
    new: 'Новый',
    processing: 'В обработке',
    ready: 'Готов'
};
